module.exports = __webpack_public_path__ + "img/image_slide5_2.d935016e.png";